import React from "react";

class DropdownGrpContas extends React.Component {
  render() {
    return (
      <React.Fragment>
        <option></option>
        <option value="V001">V001 - Clientes ISQ Nacionais</option>
        <option value="V002">V002 - Clientes ISQ Intracomunitários</option>
        <option value="V003">V003 - Clientes ISQ Países Terceiros</option>
        <option value="V005">V005 - Filiais - Outras Moradas</option>
        <option value="V007">V007 - Outros devedores</option>
        <option value="V008">V008 - Cliente - Livros</option>
        <option value="V009">V009 - Projectos Financiados</option>
        <option value="V010">V010 - Sócios ISQ</option>
        <option value="V011">V011 - Entidades Financiadoras</option>
      </React.Fragment>
    );
  }
}

export default DropdownGrpContas;
